import {OrderDto} from "./OrderDto";
import {AlteredProductDto} from "./AlteredProductDto";

export class ConfigurationLevelDto {
    constructor(public Order: OrderDto, public Product: AlteredProductDto, public Level: string, public CreateLinks: boolean) {
    }
}